import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import { FlxBuildTagComponent } from '@flowx/designer/modules/projects/components/build-tag/build-tag.component'
import { ApplicationType } from '@flowx/designer/shared/entities/application.entity'
import { ApplicationProcessData } from '@flowx/designer/shared/entities/process-instance.types'
import { BranchNameComponent } from '@flowx/designer/shared/versioning/branch-name/branch-name.component'
import { BranchStateIconComponent } from '@flowx/designer/shared/versioning/branch-state-icon/branch-state-icon.component'
import { FlxBranchStateComponent } from '@flowx/designer/shared/versioning/branch-state/branch-state.component'

@Component({
  selector: 'flx-process-instance-info',
  imports: [
    FlxBuildTagComponent,
    BranchStateIconComponent,
    BranchNameComponent,
    FlxBranchStateComponent,
    FlxIconModule,
  ],
  templateUrl: './process-instance-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessInstanceInfoComponent {
  applicationProcessData = input<Partial<ApplicationProcessData>>()
  definitionsExist = input<boolean>()
  goToProcessClicked = output()

  instanceFromBuild = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return (
      !applicationProcessData?.applicationDetails?.buildWip &&
      applicationProcessData?.applicationDetails?.buildTag
    )
  })
  appName = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.applicationDetails.appName ?? ''
  })

  buildTagVersion = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.applicationDetails.buildTag ?? ''
  })

  buildStatusAtStart = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.processData?.instance?.buildStatusAtStart
  })

  branchInfo = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.applicationDetails
  })

  buildId = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.applicationDetails?.buildId || ''
  })

  dateStarted = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.processData?.instance?.dateStarted || ''
  })

  dateFinished = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.processData?.instance?.dateFinished || ''
  })

  type = computed(() => {
    const applicationProcessData = this.applicationProcessData()
    return applicationProcessData?.applicationDetails?.applicationType === ApplicationType.APP
      ? 'Project'
      : 'Library'
  })
}
